import {
    SuccessFeedbackScreen,
    ButtonPrimary,
    skinVars,
    useWindowSize,
    ErrorFeedbackScreen,
} from '@telefonica/mistica';
import { t } from 'i18next';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import { useConfigureLineContext } from '../../../../context/configure-line-context/ConfigureLineContext';

const FeedBackMultiSimHire = () => {
    const navigate = useNavigate();
    const size = useWindowSize();
    const { simTypeSelected, duplicateSimSuccess, configureLineError, setConfigureLineError, setSimTypeSelected } =
        useConfigureLineContext();

    const naigateHome = () => {
        navigate(`/home`);
        setSimTypeSelected('PHYSICAL_SIM');
        setConfigureLineError(null);
    };

    return (
        <div
            className='feedbackMultisimHire'
            style={{
                background: duplicateSimSuccess
                    ? size.width < 1024 || size.height < 550
                        ? skinVars.colors.backgroundBrand
                        : ''
                    : skinVars.colors.background,
            }}
        >
            <>
                {duplicateSimSuccess && (
                    <SuccessFeedbackScreen
                        title={
                            simTypeSelected === 'PHYSICAL_SIM'
                                ? t('duplicateMultiSimSuccessTitle')
                                : t('duplicateMultiESimSuccessTitle')
                        }
                        description={
                            simTypeSelected === 'PHYSICAL_SIM'
                                ? t('duplicateMultiSimSuccessDesc')
                                : t('duplicateMultiESimSuccessDesc')
                        }
                        primaryButton={
                            <ButtonPrimary onPress={naigateHome}>{t('calldivertalerttextbtn')}</ButtonPrimary>
                        }
                    />
                )}
                {!duplicateSimSuccess && (
                    <ErrorFeedbackScreen
                        title={t('supportErrorFeedbackErrorOccurredTitle')}
                        description={t('profileFeedbackErrorSubtitle')}
                        errorReference={
                            configureLineError?.response?.status
                                ? `${t('feedbackCodeError')} ${configureLineError?.response?.status}`
                                : ''
                        }
                        primaryButton={
                            <ButtonPrimary onPress={naigateHome}>{t('calldivertalerttextbtn')}</ButtonPrimary>
                        }
                    />
                )}
            </>
        </div>
    );
};

export default FeedBackMultiSimHire;
